import React from 'react';
import bottomImage3 from '../assets/bottomThree/3.svg';

const TipsSection = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="py-4">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">Tennis Tips, Straight to You</h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl">
              Weekly training drills, fitness tips, and game insights delivered directly to your inbox. Stay 
              motivated, stay learning, and keep improving between lessons.
            </p>
            
            {/* <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email address"
                className="email-input"
              />
              <button className="btn btn-primary subscribe-btn">Subscribe</button>
            </div> */}
            
            {/* <div className="tips-preview">
              <h4>Recent Tips:</h4>
              <ul>
                <li>Perfect your serve with these 5 techniques</li>
                <li>Mental preparation for competitive matches</li>
                <li>Footwork drills to improve court coverage</li>
              </ul>
            </div> */}
          </div>
          
          <div>
            <img 
              src={bottomImage3}
              alt="Tennis player practicing at night"
              className="w-full h-auto rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.1)]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TipsSection;
